// services/referenceService.js
import axios from "axios";
import { API_BASE } from "../ApiUrl";

export const fetchReferenceValues = async (optionSet) => {
  console.log(`Fetching reference values for option set: ${optionSet}`);
  try {
    const response = await axios.get(`${API_BASE}/reference-values/`);
    if (response.data.success) {
      const data = response.data.data;
      console.log("Fetched reference values:", data);
      // Filter by option_set if provided.
      // Support old string form and new FK object form.
      if (optionSet) {
        console.log(`Filtering reference values for option set: ${optionSet}`);
        const filteredData = data.filter((item) => {
          return (
            item.option_set === optionSet ||
            item.option_set?.option_type === optionSet ||
            item.option_set?.option_type?.toString() === optionSet ||
            item.option_set_value?.option_type === optionSet ||
            item.option_set_value?.option_type?.toString() === optionSet
          );
        });
        console.log('Filtered reference values:', filteredData);
        return filteredData;
      }
      console.log('Returning unfiltered reference values:', data);
      return data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching reference values:", error);
    return [];
  }
};

export const getOptionsFromReference = (referenceData, labelKey = 'label', valueKey = 'id') => {
  return referenceData.map(item => ({
    value: item[valueKey],
    label: item[labelKey]
  }));
};